const apiUrl = `https://api.almasecret.msit-demo.fr`;

export function getUserProfileImageURL(userId) {
  return `${apiUrl}/users/${userId}/image?timestamp=${new Date().getTime()}`;
}
export function getUserProfilenewsImageURL(newsId) {
  return `${apiUrl}/news/${newsId}/image?timestamp=${new Date().getTime()}`;
}

export function exportCSV(csvHeaders = [], data = [], fileName = "") {
  const csvRows = data.map((item) =>
    csvHeaders.map((field) => `${item[field]}`)
  );

  const csvContent = csvHeaders + "\n" + csvRows.join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
